import { render, staticRenderFns } from "./SpaceListItem.vue?vue&type=template&id=b9d19564&scoped=true"
import script from "./SpaceListItem.vue?vue&type=script&lang=ts"
export * from "./SpaceListItem.vue?vue&type=script&lang=ts"
import style0 from "./SpaceListItem.vue?vue&type=style&index=0&id=b9d19564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d19564",
  null
  
)

export default component.exports